module.exports = __webpack_public_path__ + "media/honey-icons/icon-actions-2ee75d3e.svg";